// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/kpi-individuals/requests",
  Create: "/pyr/kpi-individuals/requests",
  Update: "/pyr/kpi-individuals/requests",
  Detail: "/pyr/kpi-individuals/requests",
  Approve: "/pyr/kpi-individuals/requests/approve",
};
